import { render, staticRenderFns } from "./ConvergeIntegrationTesting.vue?vue&type=template&id=ddf70062&"
import script from "./ConvergeIntegrationTesting.vue?vue&type=script&lang=ts&"
export * from "./ConvergeIntegrationTesting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports